export default __webpack_public_path__ + "static/media/resizeRows.d09b2dcc.gif";